export enum RegulationTypeEnum {
  INTERNAL_PROCEDURE = 'INTERNAL_PROCEDURE',
  REGULATION = 'REGULATION'
}
